


















import { useDeskStore } from "@/pinia/desk-store";
import { FloorplanMarker, useFloorplanStore } from "@/pinia/floorplan-store";
import { deskService } from "@/services/desk";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
    name: "sidebarEdit",
    components: {},
    props: {},
    setup(props, ctx) {
        const floorplanStore = useFloorplanStore();

        return { floorplanStore };
    },
});
